import {State} from '../../Store';
import {Store} from 'vuex';
import {
	EditorDialogDesktopLoginMutation,
	EditorDialogDesktopLoginShowOptions,
	EditorDialogDesktopLoginShowOptionsWithCallback,
	EditorDialogDesktopLoginState,
	EditorDialogDesktopLoginSaveCallback,
} from '../../modules/editor/DialogDesktopLogin';

import {DesktopLoginOptions} from '../../../types';

export class EditorDialogDesktopLoginStoreControllerClass {
	private _store!: Store<State>;

	private static _instance: EditorDialogDesktopLoginStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogDesktopLoginStoreControllerClass());
	}

	private constructor() {}

	set_store(store: Store<State>) {
		this._store = store;
	}

	// getters
	get local_state(): EditorDialogDesktopLoginState {
		return (<unknown>(this._store.state.editor as any).dialog_desktop_login) as EditorDialogDesktopLoginState;
	}
	display(): boolean {
		return this.local_state.display;
	}

	on_accept(): EditorDialogDesktopLoginSaveCallback | undefined {
		return this.local_state.on_accept;
	}

	// mutations
	async show(options: EditorDialogDesktopLoginShowOptions = {}): Promise<DesktopLoginOptions> {
		return new Promise((resolve, reject) => {
			const options_with_callback: EditorDialogDesktopLoginShowOptionsWithCallback = {
				on_accept: resolve,
			};
			this._store.commit(
				`editor/dialog_desktop_login/${EditorDialogDesktopLoginMutation.SHOW}`,
				options_with_callback
			);
		});
	}
	hide() {
		this._store.commit(`editor/dialog_desktop_login/${EditorDialogDesktopLoginMutation.HIDE}`);
	}
}

export const EditorDialogDesktopLoginStoreController = EditorDialogDesktopLoginStoreControllerClass.instance();
